import React from 'react';

const AdminTariffsPage: React.FC = () => (
  <>
    {/* Topbar */}
    <div style={{ height: 50, flexShrink: 0, background: 'var(--topbar-bg)', borderBottom: '1px solid var(--divider)', display: 'flex', alignItems: 'center', padding: '0 20px' }}>
      <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-primary)' }}>Tariffs</div>
    </div>

    {/* Placeholder */}
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12 }}>
      <div style={{ fontSize: 36, opacity: .35 }}>🚧</div>
      <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--text-secondary)' }}>Section under development</div>
      <div style={{ fontSize: 13, color: 'var(--text-disabled)' }}>Tariff management will be available in a future update</div>
    </div>
  </>
);

export default AdminTariffsPage;
